import { DateUtils } from '@jaam/commons';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export type Language = {
  code: string;
  label: string;
  value: string;
};

// Define supported languages
export const languageOptions: Language[] = [
  { code: 'en', label: 'En', value: 'English' },
  { code: 'fr', label: 'Fr', value: 'Français' },
];

export const useGlobalTranslate = () => {
  const { i18n } = useTranslation();
  const [userLanguage, setUserLanguage] = useState<string>('fr');

  /**
   * Switch Language
   * Updates state, localStorage, DateUtils locale, and i18next language
   */
  const switchLanguage = (langCode: string): void => {
    const selectedLanguage = languageOptions.find(
      (lang) => lang.code === langCode,
    );

    if (!selectedLanguage) {
      console.warn(`Unsupported language code: ${langCode}`);
      return;
    }

    setUserLanguage(langCode);
    localStorage.setItem('UserLanguage', langCode);
    DateUtils.locale(langCode);
    i18n.changeLanguage(langCode);
  };

  /**
   * Initialize Language on Component Mount
   */
  useEffect(() => {
    const savedLanguage = localStorage.getItem('UserLanguage');
    if (
      savedLanguage &&
      languageOptions.some((lang) => lang.code === savedLanguage)
    ) {
      switchLanguage(savedLanguage);
    } else {
      switchLanguage('fr'); // Default to French
    }
  }, []);

  return { userLanguage, switchLanguage };
};
